export const borrowersNamesWrapperStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  overflow: 'hidden',
  columnGap: '4px',
  rowGap: '2px',

  '& p': {
    color: ({ palette }) => palette.text.primary,
  },
};
